import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { KYMW0B00Model } from '../kymw0b00.model';

// レスポンス構造
export type GetKYMW0B00InitResponse = {
  UserId: string;
  UserName: string;
}[];

/**
 * 画像検索画面初期状態取得サービス
 * @export GetKYMW0B00InitService
 * @class GetKYMW0B00InitService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetKYMW0B00InitService extends PlessJsonResponderSub<GetKYMW0B00InitResponse> {
  model: KYMW0B00Model;
  private calbak: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetTagListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest();
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetTagListService
   */
  execute(model: KYMW0B00Model, f: () => void = null): void {
    this.model = model;
    this.calbak = f;
    this.send('getKYMW0B00Init', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetTagListService
   */
  success(data: GetKYMW0B00InitResponse) {
    this.model.updateKYMW0B00Init(data);
    if (this.calbak) this.calbak();
  }
}
